import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NsSpinnerComponent } from './components/ns-spinner/ns-spinner.component';

@NgModule({
  declarations: [NsSpinnerComponent],
  imports: [CommonModule],
  exports: [NsSpinnerComponent],
})
export class SpinnerModule {}
